import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
    children: React.ReactNode;
    containerId?: string;
}

const Portal: React.FC<PortalProps> = ({ children, containerId = 'modal-root' }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        // Create the portal container if it doesn't exist
        let container = document.getElementById(containerId);
        let created = false;

        if (!container) {
            container = document.createElement('div');
            container.id = containerId;
            container.style.position = 'fixed';
            container.style.top = '0';
            container.style.left = '0';
            container.style.width = '100%';
            container.style.height = '100%';
            container.style.pointerEvents = 'none';
            container.style.zIndex = '9999';
            document.body.appendChild(container);
            created = true;
        }

        setMounted(true);

        return () => {
            if (created && container && container.parentNode) {
                container.parentNode.removeChild(container);
            }
        };
    }, [containerId]);

    if (!mounted) return null;

    const container = document.getElementById(containerId);
    if (!container) return null;

    return createPortal(
        <div style={{ pointerEvents: 'auto' }}>
            {children}
        </div>,
        container
    );
};

export default Portal;
